<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Root application shell — renders the active route via router-view.
 */
export default defineComponent({
  name: 'App',
  /**
   * Root app setup — no reactive state; routing is delegated to vue-router.
   */
  setup() {
    return {};
  },
});
</script>

<style src="./assets/main.css"></style>
